import request from '@/utils/request'

const url1 = 'fault'
/** 获取故障统计 */
export function statistics(data) {
  return request({
    url: `${url1}/statistics`,
    method: 'post',
    data
  })
}
